import api from "./api"

export const getVehicleFormData = async () => {
  const response = await api.get("/vehicles/form-data")
  return response.data
}

export const getVehicles = async (params = {}) => {
  const response = await api.get("/vehicles", { params })
  return response.data
}

export const getVehicleById = async (vehicleId) => {
  const response = await api.get(`/vehicles/${vehicleId}`)
  return response.data
}

export const createVehicle = async (vehicleData) => {
  const response = await api.post("/vehicles", vehicleData)
  return response.data
}

export const updateVehicle = async (vehicleId, vehicleData) => {
  const response = await api.put(`/vehicles/${vehicleId}`, vehicleData)
  return response.data
}

export const deactivateVehicle = async (vehicleId) => {
  const response = await api.post(`/vehicles/${vehicleId}/deactivate`, {})
  return response.data
}